import "./OrdersRecap.style.css"

// Components
import NavigationBar from "../../../Components/NavigationBar"
import SideBar from "../../../Components/SideBar"

// Function
import formatRupiah from "../../../Function/formatRupiah";

// React Bootstrap
import { Button, InputGroup, Form, Table, Spinner, Placeholder } from "react-bootstrap";

// React Bootstrap Icons
import { ArrowRepeat, Search } from "react-bootstrap-icons";

// React
import { useEffect, useState } from "react";

// React Router Dom
import { useNavigate } from "react-router-dom";

// Axios
import axios from "axios";

const PageOrdersRecap = () => {
    const navigate = useNavigate();

    const [isPageLoading, setIsPageLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [accessToken] = useState(localStorage.getItem("accessToken"));
    // const [userData] = useState(JSON.parse(localStorage.getItem("userData")));

    const [orderData, setOrderData] = useState([]);
    const [orderSearch, setOrderSearch] = useState(new Date().toISOString().slice(0, 10));
    const [orderType, setOrderType] = useState("status");

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) return navigate("/");

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/order/recap?search=${new Date().toISOString().slice(0, 10)}`).then((res) => {
                setOrderData(res.data.data);
            }).catch((err) => {
                if (err.status === 404) setOrderData(err.response.data);
                else setOrderData({"message": "Internal Server Error"});
            })

            await setTimeout(() => setIsPageLoading(false), 500);
            return 1;
        }       

        fetchData();
    }, [navigate, accessToken]);

    const handleSearchOrders = async (isSync) => {
        if (isLoading) return 1;

        setIsLoading(true);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.get(`${process.env.REACT_APP_API_URL}/api/order/recap?search=${orderSearch}&update=${isSync ? "true" : "false"}`).then((res) => {
            setOrderData(res.data.data);

            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);

            if (err.status === 404) setOrderData(err.response.data);
            else setOrderData({"message": "Internal Server Error"});
        })
        return 1;
    }

    return (
        <section id="orders-recap" className="orders-recap">
            {/* Navigation Bar */}
            <NavigationBar />

            <div className="content-wrapper">
                {/* Side Bar */}
                <SideBar />

                <div className="contents">
                    {!isPageLoading ? (
                        <>
                            <header>
                                <h4 style={{ textTransform: "capitalize" }}>Orders - {orderType}</h4>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <InputGroup>
                                        <Form.Control type="date" placeholder="Search Orders" value={orderSearch} onChange={(e) => setOrderSearch(e.target.value)} disabled={isLoading} />
                                        <Button variant="primary" onClick={() => handleSearchOrders(false)} disabled={isLoading}>{isLoading ? <Spinner size="sm" /> : <Search />}</Button>
                                        <Button variant="secondary" onClick={() => handleSearchOrders(true)} disabled={isLoading}>{isLoading ? <Spinner size="sm" /> : <ArrowRepeat />}</Button>
                                    </InputGroup>
                                    <Button variant="success" disabled={isLoading} onClick={() => setOrderType(orderType === "status" ? "payment" : "status")}>{orderType === "status" ? "Payment" : "Status"}</Button>
                                </div>
                            </header>
                            <main>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>{orderType === "payment" ? "Cash" : "Success"}</th>
                                            <th>{orderType === "payment" ? "Transfer" : "Pending"}</th>
                                            <th>{orderType === "payment" ? "Credit" : "Failed"}</th>
                                            <th>Overall</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderData?.[orderType]?.daily && Object.entries(orderData?.[orderType]?.daily).map(([date, data]) => (
                                            <tr key={date}>
                                                <td>{date}</td>
                                                <td>{orderType === "payment" ? formatRupiah(data.total_cash) : data.total_success}</td>
                                                <td>{orderType === "payment" ? formatRupiah(data.total_transfer) : data.total_pending}</td>
                                                <td>{orderType === "payment" ? `${formatRupiah(data.balance_credit)} / ${formatRupiah(data.total_credit)}` : data.total_failed}</td>
                                                <td>{orderType === "payment" ? formatRupiah(data.total_overall) : data.total_overall}</td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td className="fw-bold">Overall</td>
                                            <td>{orderType === "payment" ? formatRupiah(orderData?.[orderType]?.overall.total_cash) : orderData?.[orderType]?.overall.total_success}</td>
                                            <td>{orderType === "payment" ? formatRupiah(orderData?.[orderType]?.overall.total_transfer) : orderData?.[orderType]?.overall.total_pending}</td>
                                            <td>{orderType === "payment" ? `${formatRupiah(orderData?.[orderType]?.overall.balance_credit)} / ${formatRupiah(orderData?.[orderType]?.overall.total_credit)}` : orderData?.[orderType]?.overall.total_failed}</td>
                                            <td>{orderType === "payment" ? formatRupiah(orderData?.[orderType]?.overall.total_overall) : orderData?.[orderType]?.overall.total_overall}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </main>
                        </>
                    ) : (
                        <>
                            <header>
                                <Placeholder animation="glow">
                                    <Placeholder style={{ borderRadius: "8px",  width: "150px", height: "24px" }} />
                                </Placeholder>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "250px", height: "32px" }} />
                                    </Placeholder>
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "64px", height: "32px" }} />
                                    </Placeholder>
                                </div>
                            </header>
                            <main>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "50px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.from({ length: 31 }).map((_, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "100px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "100px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "100px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "100px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "100px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "100px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </main>
                        </>
                    )}
                </div>
            </div>
        </section>
    )
}

export default PageOrdersRecap